const createThemeComponents = () => ({
  MuiDataGrid: {
    styleOverrides: {
      root: {
        border: '1px solid #E0E4E4',
        '& .MuiDataGrid-cell': {
          border: 'none',
          borderBottom: '1px solid #F5F5F5',

          // add more css for customization
        },
        '& .MuiDataGrid-columnHeader': {
          borderBottom: '2px solid #E0E4E4',
        },
        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus':
          {
            outline: 'none',
          },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      // disableElevation: true,
      root: {
        textTransform: 'none',
        '&.MuiButton-contained': {
          fontSize: '16px',
          boxShadow: 'none',
          border: '1px solid #EDFBEE',
          '&:hover': {
            backgroundColor: '#EDFBEE',
            color: '#242A42',
            border: '1px solid #273D37',
          },
          '&.Mui-disabled': {
            color: '#fff',
            border: '1px solid #fff',
          },
        },
        '&.MuiButton-outlined': {
          fontSize: '16px',
          color: '#242A42',
          backgroundColor: '#F4F4F8',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#fff',
          },
        },
        '&.MuiButton-text': {
          color: '#242A42',
          fontSize: '14px',
        },
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        '& fieldset': {
          border: 'none',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: '1px solid #E5E9F2',
        },
        '&.MuiInputBase-root.Mui-disabled': {
          height: '45px',
          '& > fieldset': {
            borderColor: '#e5e9f2',
          },
        },
        '& .MuiInputBase-input.Mui-disabled': {
          WebkitTextFillColor: '#8492A6',
        },
        fontSize: '14px',
        backgroundColor: '#FFFFFF',
        color: '#3C4858',
        height: '45px',
        fontFamily: 'Inter',
        // border: '1px solid #E5E9F2',
      },
      input: {
        '&::placeholder': {
          color: '#A6A5A5',
          fontWeight: 500,
          fontSize: '12px',
          fontFamily: 'Inter',
        },
        '&[type=number]': {
          MozAppearance: 'textfield',
        },
        '&::-webkit-outer-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },
        '&::-webkit-inner-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },
      },
    },
  },
  MuiCardContent: {
    root: {
      borderRadius: '10px',
      border: '1px solid #DCDCE9',
      boxShadow: 'none',
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        marginTop: 0,
        height: 0,
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backgroundColor: '#fff',
        color: '#242A42',
        fontSize: '13px',
        boxShadow: `rgba(0, 0, 0, 0.24) 0px 3px 8px`,
      },
    },
  },
});

export default createThemeComponents;
